module.exports = require("@mui/icons-material/FilterCenterFocus");